import { useContext } from 'react';
import { PickerOptionInputStateContext } from '../../utils/InputStateContext';
export const usePickerOptionInputStateContext = () => {
    const pickerOptionInputStateContext = useContext(PickerOptionInputStateContext);
    return pickerOptionInputStateContext;
};
